import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import template from './colorFormat.jsx';
import compose from '../../hoc/compose';
import * as colorUtil from '../../util/color';
import displayNames from '../displayNames';
var isCloseOrEqual = function isCloseOrEqual(a, b) {
  return Math.abs(b - a) <= 3;
};
var ColorFormat = /*#__PURE__*/function (_React$Component) {
  function ColorFormat(props) {
    var _this;
    _classCallCheck(this, ColorFormat);
    _this = _callSuper(this, ColorFormat, [props]);
    _this.state = {
      format: 'HEX',
      hsb: colorUtil.hexToHsb(_this.props.value)
    };
    _this.formats = [{
      value: 'HEX',
      label: 'HEX'
    }, {
      value: 'RGB',
      label: 'RGB'
    }, {
      value: 'HSB',
      label: 'HSB'
    }];
    _this.hexValidator = function (hex) {
      return /^[0-9a-f]{6}$/i.test(hex);
    };
    _this.getRGB = function () {
      return colorUtil.hexToRgb(_this.props.value);
    };
    _this.getHSB = function () {
      return colorUtil.hexToHsb(_this.props.value);
    };
    _this.onRGBChange = function (val, key) {
      return _(_this.props.value).thru(colorUtil.hexToRgb).assign(_defineProperty({}, key, val)).thru(colorUtil.rgbToHex).thru(_this.props.onChange).value();
    };
    var updateHsb = function updateHsb(hsb, key) {
      var hex = colorUtil.hsbToHex(hsb);
      _this.setState({
        hsb: hsb,
        lastChange: key
      }, function () {
        _this.props.onChange(hex);
      });
    };
    _this.onHSBChange = function (val, key) {
      return _(_this.state.hsb).assign(_defineProperty({}, key, val)).thru(function (hsb) {
        return updateHsb(hsb, key);
      }).value();
    };
    _this.onHexPaste = function (e) {
      var paste = e.clipboardData.getData('text');
      if (colorUtil.isHexString(paste)) {
        e.preventDefault();
        _this.props.onChange(colorUtil.fixShortHexIfNeeded(paste));
      }
    };
    return _this;
  }
  _inherits(ColorFormat, _React$Component);
  return _createClass(ColorFormat, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;
      var lastChange = this.state.lastChange;
      var hsb = colorUtil.hexToHsb(nextProps.value);
      var shouldKeepHue = function shouldKeepHue() {
        return hsb.saturation < 5 || hsb.brightness < 5 || isCloseOrEqual(hsb.hue, _this2.state.hsb.hue);
      };
      var stateChange = lastChange ? {
        lastChange: null
      } : {
        hsb: _.defaults({
          hue: shouldKeepHue() ? this.state.hsb.hue : hsb.hue
        }, hsb)
      };
      this.setState(stateChange);
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);
}(React.Component);
ColorFormat.displayName = displayNames.COLOR_FORMAT;
ColorFormat.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** The current value as a HEX color (e.g. `#FF2C5A`) */
  value: PropTypes.string.isRequired,
  /** Invoked on color change. Parameter: `color` {string} - the new value after the change */
  onChange: PropTypes.func.isRequired,
  /** Text content to display in case of an input error */
  invalidHexMessage: PropTypes.string
};
ColorFormat.defaultProps = {};
export default compose(ColorFormat);